"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTabs = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var primitives_1 = require("../../primitives");
var useIsMobile_1 = require("./useIsMobile");
var Badge_1 = require("./Badge");
var UserTabs = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var _j = _a.LinkComponent, LinkComponent = _j === void 0 ? react_1.Link : _j, userInfo = _a.userInfo, siteInfo = _a.siteInfo, _js = _a._js, activeTab = _a.activeTab, tabsProps = __rest(_a, ["LinkComponent", "userInfo", "siteInfo", "_js", "activeTab"]);
    var id = userInfo.id, name = userInfo.name;
    var hasNotifications = userInfo.notifications !== undefined && userInfo.notifications > 0;
    var numberOfPeriodicReviewRequests = (_c = (_b = userInfo.periodicReviewTotals) === null || _b === void 0 ? void 0 : _b.numberOfPeriodicReviewRequests) !== null && _c !== void 0 ? _c : 0;
    var numberOfUpcomingPeriodicReviews = (_e = (_d = userInfo.periodicReviewTotals) === null || _d === void 0 ? void 0 : _d.numberOfUpcomingPeriodicReviews) !== null && _e !== void 0 ? _e : 0;
    var totalPeriodicReviewsNeedingAttention = numberOfPeriodicReviewRequests + numberOfUpcomingPeriodicReviews;
    var tabs = [
        {
            type: 'about',
            href: "/User/About/".concat(id, "/").concat(name),
            label: _js('About'),
            isEnabled: true,
        },
        {
            type: 'activity',
            href: "/User/Activity/".concat(id, "/").concat(name),
            label: _js('Activity'),
            isEnabled: Boolean((_f = userInfo.permissions) === null || _f === void 0 ? void 0 : _f['canIViewUserActivity']),
        },
        {
            type: 'reputation',
            href: "/User/Graph/".concat(id, "/").concat(name),
            label: _js('Reputation'),
            isEnabled: Boolean((siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo['feature-answers']) || (siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo['feature-public-editing'])),
        },
        {
            type: 'notifications',
            href: "/User/Notifications/".concat(id, "/").concat(name),
            label: _js('Notifications'),
            isEnabled: Boolean((siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo['in-page-notification-menu']) &&
                ((_g = userInfo.permissions) === null || _g === void 0 ? void 0 : _g['canIViewUserNotifications'])),
            badge: hasNotifications
                ? {
                    value: String(userInfo.notifications),
                    color: 'yellow.500',
                }
                : null,
        },
        {
            type: 'signoffs',
            href: "/User/Signoffs/".concat(id, "/").concat(name),
            label: _js('Pending Signoffs'),
            isEnabled: Boolean(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo['feature-supervisor-signoff']),
        },
        {
            type: 'work_orders',
            href: "/User/work_orders/".concat(id, "/").concat(name),
            label: _js('Work Orders'),
            isEnabled: Boolean(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo['feature-data-entry']),
        },
        {
            type: 'periodic_reviews',
            href: "/User/periodic_reviews/".concat(id, "/").concat(name),
            label: _js('Periodic Reviews'),
            isEnabled: Boolean(siteInfo === null || siteInfo === void 0 ? void 0 : siteInfo['feature-periodic-review']),
            badge: totalPeriodicReviewsNeedingAttention > 0
                ? {
                    value: String(totalPeriodicReviewsNeedingAttention),
                    color: ((_h = userInfo.periodicReviewTotals) === null || _h === void 0 ? void 0 : _h.hasOverduePeriodicReviews)
                        ? 'red.500'
                        : 'yellow.500',
                }
                : null,
        },
    ];
    var isMobile = (0, useIsMobile_1.useIsMobile)();
    var enabledTabs = tabs.filter(function (tab) { return tab.isEnabled; });
    var activeTabIndex = enabledTabs.findIndex(function (tab) { return tab.type === activeTab; });
    if (isMobile) {
        return (React.createElement(react_1.Box, null, enabledTabs.map(function (tab, index) { return (React.createElement(LinkComponent, { key: "userTabs-".concat(tab.type), href: tab.href, "aria-label": "".concat(tab.label, " Tab") },
            React.createElement(react_1.Text, { color: index === activeTabIndex ? 'blue.500' : undefined, position: "relative", borderColor: "blackAlpha.100", borderWidth: 1, borderStyle: 'solid', margin: 0, paddingY: 2, paddingLeft: 2 },
                tab.label,
                tab.badge && (React.createElement(Badge_1.Badge, { text: tab.badge.value, top: 2, right: 2, backgroundColor: tab.badge.color }))))); })));
    }
    return (React.createElement(react_1.Tabs, __assign({ variant: "enclosed", index: activeTabIndex }, tabsProps),
        React.createElement(react_1.TabList, { width: "100%" }, enabledTabs.map(function (tab) { return (React.createElement(LinkComponent, { key: "userTabs-".concat(tab.type), href: tab.href, "aria-label": "".concat(tab.label, " Tab") },
            React.createElement(react_1.Tab, { position: "relative" },
                tab.label,
                tab.badge && (React.createElement(Badge_1.Badge, { text: tab.badge.value, top: "-".concat(primitives_1.space[1]), right: "-".concat(primitives_1.space[1]), backgroundColor: tab.badge.color }))))); }))));
};
exports.UserTabs = UserTabs;
